import { InputsContextProvider } from './calculator/inputs-context-provider';

interface AppContextProviderProps {
    children: React.ReactNode;
}

export const AppContextProvider = ({ children }: AppContextProviderProps) => (
    <InputsContextProvider>{children}</InputsContextProvider>
);
